import { Controller } from "react-hook-form";
import { SwitchField } from "../../ui";

export interface InputProps {
    name: string;
    subName?: string;
    label: string;
    methods: any;
    disabled?: boolean;
}

export function InputSwitch({ name, label, methods, disabled }: InputProps) {
    return (
        <Controller
            name={name}
            control={methods.control}
            defaultValue={false}
            render={({ field }) => (
                <SwitchField
                    checked={!!field.value}
                    onChange={(checked) => field.onChange(checked)}
                    disabled={disabled}
                    label={label}
                />
            )}
        />
    );
}